<template>
  <div class="container">

    <main-top step-number="2"/>

    <div class="main-content">

      <div class="row white-box">
        <div class="list order-list print2-list animate">
          <div class="list-title">
            <span class="title fs16">
              <i v-bind:class="['icon-fileext', 'icon-' + fileExt(file.fileName) + '-small']"></i>
              {{ file.fileName }}
            </span>
            <!--<div class="opts-group fr">-->
              <!--<span class="btn btn-default">印箱打印</span>-->
            <!--</div>-->
          </div>
          <div class="print-setting animate">
            <div class="row">
              <div class="col-lg-3">页数</div>
              <div class="col-lg-9">
                <div class="opts-group number-group">
                  <template v-if="file.pageCount">
                     {{ file.pageCount }} 页
                  </template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">打印份数</div>
              <div class="col-lg-9">
                <div class="opts-group number-group">
                  <i class="icon-number-reduce fl" v-on:click="reduceCopies"></i>
                  <input class="fl" name="copies" type="text" value="1" v-model="copies">
                  <i class="icon-number-add fl" v-on:click="addCopies"></i>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">单/双面</div>
              <div class="col-lg-9">
                <div class="opts-group dropdown">
                  <a id="drop_side_type" href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <span class="text">{{ sideType.name }}</span>
                    <span class="caret"></span>
                  </a>
                  <ul id="drop_side_type_menu" class="dropdown-menu" aria-labelledby="drop_side_type">
                    <li>
                      <a v-on:click="setValue('sideType', '1', '单面')">单面</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('sideType', '2', '双面')">双面</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('sideType', '3', '横版双面')">横版双面</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">纸张色彩</div>
              <div class="col-lg-9">
                <div class="opts-group dropdown">
                  <a id="drop_paper_color" href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <span class="text">{{ colorType.name }}</span>
                    <span class="caret"></span>
                  </a>
                  <ul id="drop_paper_color_menu" class="dropdown-menu" aria-labelledby="drop_paper_color">
                    <li>
                      <a v-on:click="setValue('colorType', '1', '黑白')">黑白</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('colorType', '2', '彩色')">彩色</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">纸张类型</div>
              <div class="col-lg-9">
                <div class="opts-group dropdown">
                  <a id="drop_paper_type" href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <span class="text">{{ paperType.name }}</span>
                    <span class="caret"></span>
                  </a>
                  <ul id="drop_paper_type_menu" class="dropdown-menu" aria-labelledby="drop_paper_type">
                    <li>
                      <a v-on:click="setValue('paperType', 'A4', 'A4纸')">A4纸</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('paperType', 'A3', 'A3纸')">A3纸</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">布局</div>
              <div class="col-lg-9">
                <div class="opts-group dropdown">
                  <a id="drop_numbers" href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <span class="text">{{ numbers.name }}</span>
                    <span class="caret"></span>
                  </a>
                  <ul id="drop_numbers_menu" class="dropdown-menu" aria-labelledby="drop_numbers">
                    <li>
                      <a v-on:click="setValue('numbers', '1', '1页/版')">1页/版</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('numbers', '2', '2页/版')">2页/版</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('numbers', '4', '4页/版')">4页/版</a>
                    </li>
                    <li>
                      <a v-on:click="setValue('numbers', '6', '6页/版')">6页/版</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 text-center">

                <div class="col-lg-3 mb10" >
                  <div class="input-group">
                    <i class="icon-cash"></i>
                    <span class="price-cash">{{ price/100 }}</span>
                  </div>
                </div>
                <div class="col-lg-3 left">
                  <span >( 账户余额:{{ user.balance/100 }} )</span>
                </div>
                <div class="col-lg-6 ">
                  <button class="btn btn-default " type="button" v-on:click="payWallet">余额支付</button>
                  <button class="btn btn-default " type="button" v-on:click="payWechat">微信支付</button>
                </div>


                <!--<button class="btn btn-default btn-highlight" type="button" v-on:click="submit">提交订单</button>-->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <main-right/>

    <!--<modal-pay :order="order"/>-->
    <modal-wechat-pay :order="order" @payResult="payResult"/>

  </div>
</template>

<script>
  import {showModal, hideModal, ajax} from '@/api/global'

  import MainTop from '@/components/MainTop'
  import MainRight from '@/components/MainRight'
  import ModalWechatPay from "../components/ModalWechatPay";

  export default {
    name: "PagePrintSetting",
    components: {
      ModalWechatPay,
      MainTop,
      MainRight
    },
    props: ['isLogin'],
    data: function () {
      return {
        file : {
          ext : ''
        },
        user: {},         //用户信息
        copies : 1,         // 打印份数
        numbers : {        //打印板式
          value: 1,
          name: '1页/版'
        },
        colorType : {
          value : '1',     // 2 / 1
          name : '黑白'            // 彩色 / 黑白
        },
        pageCount : 0,  // 单份文件的总页数，
        paperType : {
          value : 'A4',      // 打印类型，1:A4纸 ;2:其他，默认为1
          name : 'A4纸'       // A4纸 / 其他
        },
        sideType : {
          value : 1,      // 打印方式，1:单面打印 ;2:双面打印，默认为1
          name : '单面'       // 单面打印 / 双面打印
        },
        fileId : '',         // 文件id
        order : {
          orderId: '',
          price: 0,
          qrcodeurl: '',
          walletRecordId: ''
        },
        printFeeSTD: [],       //费率列表
        realPagecount: 0,       //总页数
        fee: 0,                //单价
        price: 0              //订单金额
      }
    },
    methods: {
      fileExt(file) {
        // console.info('filename:'+JSON.stringify(file));
        let filename = file;
        let index1=filename.lastIndexOf(".");
        let index2=filename.length;
        let type=filename.substring(index1+1,index2).toLowerCase();
        // console.info(type);
        return type;
      },
      createOrder : function () {
        var self = this;
        console.info('create order');

        console.info(self.paperType);

        var data = {
          orderType: '1',
          fileId: self.fileId,
          paperType: self.paperType.value,
          sideType: self.sideType.value,
          colorType: self.colorType.value,
          numbers: self.numbers.value,
          copies: self.copies,
          fee: self.fee,
          realPagecount: self.realPagecount,
          price: self.price
        };

        console.info(data);

        ajax({
          // mock : Mock.orderSubmit,
          url : 'api/app-service/order',
          type : 'post',
          async : false,
          data : data,
          success : function (res) {
            self.order.orderId = res.data;
            self.order.price = self.price;
            // if (res.data.status == 2) {
            //   self.paySuccess();            // 支付价格为0,直接提示支付成功
            // } else {
            // console.info('show modal Pay' + self.order);
            // showModal('pay');
            // }
          }
        });
      },
      payResult (result) {
        if (result) {
          this.payWallet()
        }

      },
      paySuccess : function () {
        alert('支付成功, 请前往附近印箱打印!');
        // this.$vDialog.alert('支付成功, 请前往附近印箱打印!', null, {messageType: 'success'});
        hideModal('wechatpay');
        router.push('/print-map');
      },
      getFileDetail : function () {
        var self = this;
        ajax({
          // mock : Mock.fileDetail,
          urlext : 'fileId',
          url : 'api/app-service/getUserFile',
          async : false,
          data : {
            id : self.fileId
          },
          type : 'get',
          success : function (res) {
            console.info(JSON.stringify(res));
            self.file = res.data;
            self.pageCount = self.file.pageCount;
            // this.changeOpt();
          }

        });
      },
      addCopies : function () {
        this.copies = parseInt(this.copies) + 1;
        this.changeOpt();
      },
      reduceCopies : function () {
        this.copies = parseInt(this.copies) > 1 ? parseInt(this.copies) - 1 : 1;
        this.changeOpt();
      },
      setValue : function (key, value, name) {
        this[key].value = value;
        this[key].name = name;
        this.changeOpt();
      },
      changeOpt () {
        var self = this;
        // let ii =0;
        // while ((self.printFeeSTD.length == 0)&&(ii<3)) {
        //   ii++;
        //   console.info('第'+ii+'次请求费率');
        //   self.getPrintFeeSTD()
        // }
        // if (self.printFeeSTD < 1) {
        //   alert('获得费率失败，请联系管理员!');
        //   return;
        // }

        // console.log("paperType :" + self.paperType.value);
        // console.log("colorType :" + self.colorType.value);

        self.order.orderId = '';
        var std = self.printFeeSTD;

        // console.info(JSON.stringify(std));

        if(std && std.length > 0) {
          for(var i = 0; i < std.length; i++) {
            if((self.paperType.value == std[i].paperType) &&
              (self.colorType.value == std[i].colorType) &&
              (std[i].orderType == '1') ) {     //web端直可以打印文档
              console.log("得到方案:" + JSON.stringify(std[i]));
              self.fee = parseInt(std[i].fee);
              break;
            }
          }
          console.log("单价：" + self.fee);

          self.realPagecount = Math.ceil(parseInt(self.copies) * self.pageCount/parseInt(self.numbers.value));
          console.log("页数：" + self.realPagecount);

          self.price = self.fee * self.realPagecount;
          console.log("费用：" + self.price);

        }
      },
      getPrintFeeSTD () {
        var self = this;
        ajax({
          url : 'api/app-service/getFeeSTD',
          async: false,
          data : {},
          type : 'get',
          success : function (res) {
            console.info(JSON.stringify(res));
            self.printFeeSTD = res.data;
          }
        });
      },
      getUserInfo : function () {
        var self = this;

        ajax({
          // mock : Mock.userInfo,
          url : 'api/app-service/userinfo',
          type : 'get',
          success : function (res) {
            self.user = res.data;
            console.info(self.user);
          }
        });
      },
      payWallet () {
        var self = this;
        if (self.order.orderId=='') self.createOrder();

        ajax({
          // mock : Mock.userInfo,
          url : 'api/app-service/pay/app/paywallet',
          type : 'post',
          data : {
            orderids: JSON.stringify([self.order.orderId]),
            sumPrice: self.order.price,
            bonusId:'',
            usedPages: 0
          },
          success : function (res) {
            //支付成功
            console.info(res.data);
            alert('支付成功, 请前往附近印箱打印!');
            // this.$vDialog.alert('支付成功, 请前往附近印箱打印!', null, {messageType: 'success'});
            location.href = '/print-map';
          },
          error : function (e) {
            alert('支付未成功!');
            // this.$vDialog.alert('支付未成功!', null, {messageType: 'error'});
          }
        });
      },
      payWechat () {
        var self = this;
        if (self.order.orderId=='') self.createOrder();
        console.info('self.order.orderId : '+self.order.orderId);

        ajax({
          // mock : Mock.userInfo,
          url : 'api/app-service/pay/app/recharge',
          type : 'get',
          data : {
            pay_channel: 'WX_NATIVE',
            sum: self.order.price
          },
          success : function (res) {
            //支付成功
            console.info(res.data);
            self.order.qrcodeurl = res.data.qrcodeUrl;
            self.order.walletRecordId = res.data.walletRecordId;
            showModal('wechatpay');
            // alert('支付成功, 请前往附近印箱打印!');
            // location.href = '/print-map';
          },
          error : function (e) {
            alert('支付通道异常，请联系管理员!');
            // this.$vDialog.alert('支付未成功!', null, {messageType: 'error'});
          }
        });

      },
      checkPayStatue : function () {
        if (/fail/.test(location.href)) {
          alert('支付未成功!');
          // this.$vDialog.alert('支付未成功!', null, {messageType: 'error'});
        } else if (/success/.test(location.href)) {
          alert('支付成功, 请前往附近印箱打印!');
          // this.$vDialog.alert('支付成功!', null, {messageType: 'success'});
          location.href = '/print-map';
        }
      }
    },
    created: function () {
      console.info('page-print-setting-init   CREATED');
      this.fileId = this.$route.params.id || '';
      this.getUserInfo();
      this.getFileDetail();
      this.getPrintFeeSTD();
      this.checkPayStatue();
    },
    mounted () {
      console.info('page-print-setting-init  MOUNTED');
    },
    watch: {
      pageCount: function(curVal,oldVal) {
        console.info('pageCount : '+ oldVal +'->'+curVal);
        this.changeOpt();
      }
      // pageCount:function(curVal,oldVal){
      //   console.info('pageCount : '+ oldVal +'->'+curVal);
      //     this.$nextTick(function(){
      //     this.changeOpt();
      //   });
      // }

    },
  }
</script>

<style scoped>
  .icon-cash{
    top: 0px;
  }
  .price-cash{
    /*display: block;*/
    font-size: 38px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PagePrintSetting.vue